import { post } from '@/common/utils/Http';

export default {
  getSearchFields: post('/customer/getSearchSettings'),
  saveSearchFields: post('/customer/saveSearchSettings'),
  getDisplayFields: post('/customer/getDisplaySettings'),
  saveDisplayFields: post('/customer/saveDisplaySettings'),
  suggest: post('/customer/search'),
  getList: post('/customer/filter'),
  getProps: post('/customer/getProps'),
  getRemarks: post('/customer/getRemarks'),
  getRemarkInfo: post('/customer/getRemarkInfo'),
  setRemarks: post('/customer/setRemarks'),
  getRemarksById: post('/customer/getRemarksById'),
  getFullRemarksByIds: post('/customer/getFullRemarksByIds'),
  renameRemark: post('/customer/renameRemark'),
  updateRemarkName: post('/customer/updateRemarkName'),
  getGroups: post('/customer/getGroups'),
  updateGroup: post('/customer/updateGroup'),
  addGroup: post('/customer/addGroup'),
  batchAppendGroup: post('/customer/batchAppendGroup'),
  batchRemoveGroup: post('/customer/batchRemoveGroup'),
  removeGroup: post('/customer/removeGroup'),
  createProp: post('/customer/createProp'),
  renameProp: post('/customer/renameProp'),
  getMemberCards: post('/member/getCards'),
  batchAppendRemark: post('/customer/batchAppendRemark'),
  uploadFieldExcel: post('/customer/uploadFieldExcel'),
  uploadImportExcel: post('/customer/uploadImportExcel'),
  deleteProp: post('/customer/deleteProp'),
  getTraces: post('/trace/getTraces'),
  setTraceStatus: post('/trace/setTraceStatus'),
  getTraceStatus: post('/trace/getTraceStatus'),
  getTraceCount: post('/trace/getTraceCount'),
  getSexGroup: post('/customer/getSexGroup'),
  getLanguageGroup: post('/customer/getLanguageGroup'),
  getProvinceGroup: post('/customer/getProvinceGroup'),
  getCityGroup: post('/customer/getCityGroup'),
  getSubscribeGroup: post('/customer/getSubscribeGroup'),
  getScoreGroup: post('/customer/getScoreGroup'),
  getInteractiveGroup: post('/customer/getInteractiveGroup'),
  getScoreDetails: post('/member/getScoreDetails'),
  syncCustomer: post('/customer/syncCustomer'),
  syncReadCustomer: post('/customer/syncReadCustomer'),
  updateProp: post('/customer/updateProp'),
  createRemarkRule: post('/customer/createRemarkRule'),
  updateRemarkRule: post('/customer/updateRemarkRule'),
  deleteRemarkRule: post('/customer/deleteRemarkRule'),
  getValidRemarkRules: post('/customer/getValidRemarkRules'),
  getExpiredRemarkRules: post('/customer/getExpiredRemarkRules'),
  getDisabledRemarkRules: post('/customer/getDisabledRemarkRules'),
  getRemarkRuleIndicators: post('/customer/getRemarkRuleIndicators'),
  getRemarkRuleTrends: post('/customer/getRemarkRuleTrends'),
  createRemarkGroup: post('/customer/createRemarkGroup'),
  getRemarkGroups: post('/customer/getRemarkGroups'),
  updateRemarkGroup: post('/customer/updateRemarkGroup'),
  deleteRemarkGroup: post('/customer/deleteRemarkGroup'),
};
